import React from "react";
import { Card, CardGroup } from "react-bootstrap";
import "./Cards.css";
import card1 from "../../../images/card1.jpg";
import card2 from "../../../images/card2.jpg";
import card3 from "../../../images/card3.jpg";

const Cards = () => {
  return (
    <div>
      <h2 className="card-title"> WE ARE HERE FOR EVERY ADVENTURE!! </h2>
      <CardGroup className="all-cards">
        <Card>
          <Card.Img variant="top" src={card1} className="card-img" />
          <Card.Body>
            <Card.Text>
              Let our expert team help you make the most of your next adventure.
            </Card.Text>
          </Card.Body>
        </Card>
        <Card>
          <Card.Img variant="top" src={card2} className="card-img" />
          <Card.Body>
            <Card.Text>
              We provide the best camping gears for your comfort zone.
            </Card.Text>
          </Card.Body>
        </Card>
        <Card>
          <Card.Img variant="top" src={card3} className="card-img" />
          <Card.Body>
            <Card.Text>
              Please inform us your needed all things for the outdoor camping.
            </Card.Text>
          </Card.Body>
        </Card>
      </CardGroup>
    </div>
  );
};

export default Cards;
